import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { deserializeDetailsParams, loadMaterialesSimilaresRequest, loadStockRequest } from 'src/app/actions';
import { Acabado, DetalleStock, Disponibilidad, Filter, getUnidadMedida, Maestros, Material, Stock, UnidadMedida } from 'src/app/models';
import { ImageItem, GalleryState } from 'ng-gallery';
import { MaterialesService } from 'src/app/services';
import * as fromSelectors from 'src/app/selectors';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';
import { ModuleState } from 'src/app/state';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';


@Component({
  templateUrl: './detail.container.html',
  styleUrls: ['./detail.container.css']
})
export class DetailContainer implements OnInit {
  query: Params;
  detalles: DetalleStock[] = [];
  imgs: ImageItem[] = [];
  iconos: {icon: string, description: string}[] = [];
  maestros: Maestros;
  unidadMedida: UnidadMedida;
  currentDetalleIndex: number = 0;
  materialesSimilares: Material[] = [];
  loadingMaterialesSimilares: boolean = false;
  loadingDetails: boolean = false;
  loadingMaestros: boolean = false;
  selectedFilters: Filter[] = []
  groupByBundle: boolean = false;

  get currentDetalle(): DetalleStock {
    return this.detalles[this.currentDetalleIndex];
  }

  get language(): Language {
    return getLanguage(getLanguageFromUrl());
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private location: Location,
    private materialesService: MaterialesService) {}

  getNombreMaterial(codigo: Material['CODIGO']): string {
    return this.materialesService.getNombreMaterial(codigo, this.maestros);
  }

  getNombreTipoMaterial(id: Material['TIPOMATERIALID']): string {
    return this.materialesService.getNombreTipoMaterial(id, this.maestros);
  }

  getAcabadoMaterial(codigo: Acabado['CODIGO']): string {
    return this.materialesService.getAcabadoMaterial(codigo, this.maestros);
  }

  getAncho(val: string): string {
    return this.materialesService.getAncho(val)
  }

  getDisponibilidad(codigo: Disponibilidad['CODIGO']): string {
    return this.materialesService.getDiponibilidad(codigo, this.maestros);
  }

  getColorMaterial(codigo: Material['CODIGO']): string {
    return this.materialesService.getColorMaterial(codigo, this.maestros);
  }

  galleryIndexChange(change: GalleryState) {
    this.currentDetalleIndex = change.currIndex;
  }

  expand(): void {
    this.router.navigate([getLanguageFromUrl(), 'expand'], {queryParams: {...this.query, index: this.currentDetalleIndex}})
  }

  bookmatch(): void {
    this.router.navigate([getLanguageFromUrl(), 'bookmatch', this.currentDetalle.BLOQUE])
  }

  getUnidadLanguage(): string {
    return this.unidadMedida === UnidadMedida.CM ? 'cm' : getLanguage(getLanguageFromUrl()).PULGADAS
  }

  getMedida(medida: string): string {
    return getUnidadMedida(this.unidadMedida, parseFloat(medida)) + ' ';
  }
  
  getEspesor(medida: string): string {
    return parseFloat(medida) + ' cm';
  }

  getPiezas(piezas: string) {
    return parseFloat(piezas);
  }
  
  // getFichaTecnicaUrl(codigo: Material['CODIGO']): string {
  //   if(!this.maestros) return 'javascript:void(0)';
  //   const material: Material = this.maestros.materiales.find(m => m.CODIGO === codigo);
  //   if(!material || !material.FICHATECNICA) return 'javascript:void(0)';
  //   return material.FICHATECNICA;
  // }

  // hasFichaTecnicaUrl(codigo: Material['CODIGO']): boolean {
  //   if(!this.maestros) return false;
  //   const material: Material = this.maestros.materiales.find(m => m.CODIGO === codigo);
  //   return material && material.FICHATECNICA != null && material.FICHATECNICA != '';
  // }

  // getCarouselItem(detalle: DetalleStock): { nombre: string, src: string } {
  //   if (this.groupByBundle) {
  //     return {
  //       nombre: this.getNombreMaterial(detalle.MATERIAL),
  //       src: detalle.IMAGENURL
  //     }
  //   }
  //   else {
  //     return {
  //       nombre: this.getNombreMaterial(detalle.MATERIAL),
  //       src: detalle.IMAGENMINIURL
  //     }
  //   }
  // }

  goBack():void {
    if(this.selectedFilters.length){
      this.location.back()
    } else {
      this.router.navigate([getLanguageFromUrl()])
    }
  }

  ngOnInit(): void {
    /*console.log('INIT');
    console.log(this.detalles);
    console.log('CURRENT');
    console.log(this.currentDetalle);
    console.log(this.currentDetalleIndex);
    console.log('IMAGES');
    console.log(this.imgs);
    this.detalles = [];
    this.imgs = [];
    this.currentDetalleIndex = -1;
    */
    this.groupByBundle = environment.byBundle;

    //console.log(this.imgs?.length);

    this.store.select(fromSelectors.selectDetalles).subscribe(detalles =>{
      this.detalles = detalles;
      if (this.groupByBundle)
        this.imgs = this.detalles.map(d => new ImageItem({ src: d.IMAGENURL, thumb: d.IMAGENMINIURL }));
      else
        this.imgs = this.detalles.map(d => new ImageItem({ src: d.IMAGENMINIURL, thumb: d.IMAGENMINIURL }));

      this.store.select(fromSelectors.maestrosSelector).subscribe(async maestros => {
        if(!!maestros && !!this.detalles)
          this.iconos = (await this.materialesService.getIconosMaterial(this.detalles[0], maestros)).filter( i => !!i);
      });
      // console.log(this.imgs?.length);
      // console.log(this.loadingDetails);
    });

    this.route.queryParams.subscribe(query => {
      this.query = query;
      this.store.dispatch(deserializeDetailsParams({ query }));
      this.store.dispatch(loadMaterialesSimilaresRequest({ param: query.material }));
    })

    // Debería normalizarse dentro del estado
    this.store.select(fromSelectors.tipoMaterialSelector).subscribe(tipoMaterial => this.maestros = { ...this.maestros, tipoMaterial });
    this.store.select(fromSelectors.acabadoSelector).subscribe(acabado => this.maestros = { ...this.maestros, acabado });
    this.store.select(fromSelectors.usoMaterialSelector).subscribe(usoMaterial => this.maestros = { ...this.maestros, usoMaterial });
    this.store.select(fromSelectors.continenteSelector).subscribe(continente => this.maestros = { ...this.maestros, continente });
    this.store.select(fromSelectors.colorMaterialSelector).subscribe(colores => this.maestros = { ...this.maestros, colorMaterial: colores });
    this.store.select(fromSelectors.espesorSelector).subscribe(espesor => this.maestros = { ...this.maestros, espesor });
    this.store.select(fromSelectors.disponibilidadSelector).subscribe(disponibilidad => this.maestros = { ...this.maestros, disponibilidad });
    this.store.select(fromSelectors.rangoPrecioSelector).subscribe(rangoPrecio => this.maestros = { ...this.maestros, rangoPrecio });
    this.store.select(fromSelectors.materialesSelector).subscribe(materiales => this.maestros = { ...this.maestros, materiales });

    this.store.select(fromSelectors.materialesSimilaresSelector).subscribe(materiales =>{ /*console.log(materiales)*/
      this.materialesSimilares = materiales});

    this.store.select((state: ModuleState) => state.unidadMedida).subscribe(unidad => this.unidadMedida = unidad);

    this.store.select((state: ModuleState) => state.ui).subscribe(ui => {
      this.loadingMaterialesSimilares = ui.loadingMaterialesSimilares;
      this.loadingDetails = ui.loadingDetail;
      this.loadingMaestros = ui.loadingMaestros;
    });

    this.store.select(fromSelectors.selectedFiltersSelector).subscribe(filters => this.selectedFilters = filters);
  }
}
